<footer class="footer">
    <div class="footerTop">
        <div class="container mx-0 mx-md-auto">
            <div class="footerLinksSec">
                <div class="footerLinksInner d-md-flex">
                    <div class="footerInfoSec d-flex mb-3 mb-md-0">
                        <div class="footerLogo">
                            <a href="#"><img src="../../../assets/homepage-images/Adobe_Logo.png" alt="logo" /></a>
                        </div>
                        <!-- <div class="footerInfo">
                            <p> Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad, autem. Vel eaque natus
                                similique nobis iste libero? Iure ut veritatis beatae iusto est! Eaque laboriosam
                                ratione iste esse neque repellat!</p>
                        </div> -->
                    </div>
                    <div class="footerLinks d-md-flex">
                        <div class="linksBox">
                            <h5>Repository </h5>
                            <ul>
                                <li>
                                    <a routerLink="/endpoint" [queryParams]="{page: 1, size: 15}" id="nav-endpoint">Endpoint</a>
                                </li>
                                <li>
                                    <a routerLink="/testcase" [queryParams]="{page: 1, size: 15}" id="nav-testcase">Testcase</a>
                                </li>
                                <li>
                                    <a routerLink="/testsuite" [queryParams]="{page: 1, size: 15}" id="nav-testsuite">Testsuite</a>
                                </li>
                                <li>
                                    <a routerLink="/mastersuite" [queryParams]="{page: 1, size: 15}" id="nav-mastersuite">Mastersuite</a>
                                </li>
                            </ul>
                        </div>
                        <div class="linksBox">
                            <h5>Result </h5>
                            <ul>
                                <li>
                                    <a routerLink="/history/testcase" id="nav-history-testcase" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_CASE' }" [class.active]="isRouteActive(['/history/testcase', '/results/testcase'])">Test Case</a>
                                </li>
                                <li>
                                    <a routerLink="/history/testsuite" id="nav-history-testsuite" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_SUITE' }" [class.active]="isRouteActive(['/history/testsuite', '/results/testsuite'])">Test Suite</a>
                                </li>
                                <li>
                                    <a routerLink="/history/mastersuite" id="nav-history-mastersuite" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'MASTER_SUITE' }" [class.active]="isRouteActive(['/history/mastersuite', '/results/mastersuite'])">Master Suite</a>
                                </li>
                            </ul>
                        </div>

                        <div class="linksBox">
                            <h5>Reach us at</h5>
                            <ul>
                                <li><a href="mailto:Grp-Relay-Team@adobe.com">{{'Grp-Relay-Team@adobe.com'}}</a></li>
                            </ul>
                            <h5>Wiki links</h5>
                            <ul>
                                <li>
                                    <a href="https://wiki.corp.adobe.com/display/Relay/Relay" target="_blank">Relay</a>
                                </li>
                            </ul>
                            <h5>Slack Channel</h5>
                            <ul>
                                <li>
                                    <a href="https://adobe-relay.slack.com/" target="_blank">Adobe-Relay</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="footerSocialMedia d-flex justify-content-center">
                <ul class="d-flex">
                    <li><a href="#"><img src="../../../assets/homepage-images/social1.png" alt="social" /></a></li>
                    <li><a href="#"><img src="../../../assets/homepage-images/social2.png" alt="social" /></a></li>
                    <li><a href="#"><img src="../../../assets/homepage-images/social3.png" alt="social" /></a></li>
                    <li><a href="#"><img src="../../../assets/homepage-images/social4.png" alt="social" /></a></li>
                </ul>
            </div> -->
        </div>
    </div>
    <div class="footerBottom">
        <div class="container mx-0">
            <div class="footerBottomInner d-flex  justify-content-lg-center">
                <!-- <div class="regionSec">
                    <select class="form-control">
                        <option>Change Region</option>
                        <option>Region 1</option>
                        <option>Region 2</option>
                    </select>
                </div> -->
                <div class="copyrightSection">

                    <div class="copyrightWithLinks">
                        <ul class="d-md-flex">
                            <li classs="m-2 m-lg-0 ">Copyright © 2024 Adobe. All rights reserved.</li>
                            <li classs="m-2 m-lg-0">Privacy</li>
                            <li classs="m-2 m-lg-0">Terms of Use</li>
                            <li classs="m-2 m-lg-0">Cookie preferences</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</footer>